import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import DownloadIcon from "@mui/icons-material/Download";

export default function TableExportCsv({
  visible,
  onSimpleExport,
  disabled,
  disabledTitle,
  loading,
}) {
  if (!visible) {
    return null;
  }

  const button = (
    <Button
      variant="outlined"
      size="small"
      startIcon={
        loading ? (
          <CircularProgress size={16} color="inherit" aria-hidden />
        ) : (
          <DownloadIcon />
        )
      }
      onClick={onSimpleExport}
      disabled={disabled || loading}
      data-testid="export-csv-simple"
      aria-busy={loading || undefined}
    >
      {loading ? "Exporting…" : "Export CSV"}
    </Button>
  );

  if (
    !loading &&
    disabled &&
    typeof disabledTitle === "string" &&
    disabledTitle.trim()
  ) {
    return (
      <Tooltip title={disabledTitle} placement="top" arrow enterDelay={200}>
        <Box component="span" sx={{ display: "inline-block" }}>
          {button}
        </Box>
      </Tooltip>
    );
  }

  return button;
}

TableExportCsv.propTypes = {
  visible: PropTypes.bool,
  onSimpleExport: PropTypes.func,
  disabled: PropTypes.bool,
  disabledTitle: PropTypes.string,
  loading: PropTypes.bool,
};

TableExportCsv.defaultProps = {
  visible: true,
  onSimpleExport: undefined,
  disabled: false,
  disabledTitle: "",
  loading: false,
};
